<div #pillWrapper class="pill-wrapper" [class.hidden]="isHidden">
  @if (!pillExpanded) {
    @if (!pillMini) {
      <div class="pill-content">
        <div class="pill-content-side" (click)="onPillToggle(true)">
          <svg class="pill-content-menu-icon blue"width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="26" height="4" rx="2" fill="#2DADC8" stroke="#2DADC8"/>
            <rect x="0.5" y="12.5" width="26" height="4" rx="2" fill="#2DADC8" stroke="#2DADC8"/>
          </svg>
        </div>
  
        <div #menu class="pill-content-menu">
          @if (menuOptionsSignal().length > 1) {
            <div #selectedSection class="selected-section"></div>
          }
          @defer (when menuOptionsSignal().length > 0) {
            @for (item of menuOptionsSignal(); track i; let i = $index) {
              <div #menuItem class="pill-content-menu-item" (click)="onItemSelected($index)">
                <div class="pill-content-menu-item-header">
                  <i class="pill-content-menu-item-icon" [ngClass]="item.icon"></i>
                  <span class="pill-content-menu-item-title" [title]="item.title">{{i + 1}}. {{item.title}}</span>
                </div>
  
                <div class="pill-content-progress-bar">
                  <div class="pill-content-progress" [style.width.%]="item.progress"></div>
                </div>
  
                <div class="pill-content-time">
                  @if (item.progress === 100) {
                    <i class="fa-solid fa-check green"></i>
                    @if (item.type === 'who5') {
                      <div class="pill-content-time-text italic" (click)="onNavigateToStats()">{{ 'WebApp.v1.Shared.Pill.Survey.Completed.Stats' | translate }}</div>
                    } @else {
                      <div class="pill-content-time-text italic">{{ 'WebApp.v1.Shared.Pill.Survey.Completed' | translate }}</div>
                    }
                  } @else {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span class="pill-content-time-text">{{item.description | translate}}</span>
                  }
                </div>
              </div>
            }
          } @placeholder {
            @for (_ of [1, 2, 3, 4]; track $index) {
              <div class="pill-content-menu-item placeholder">
                <div class="pill-content-menu-item-header">
                  <div class="skeleton skeleton-icon"></div>
                  <div class="skeleton skeleton-text"></div>
                </div>
                <div class="pill-content-progress-bar">
                  <div class="skeleton skeleton-bar"></div>
                </div>
                <div class="pill-content-time">
                  <div class="skeleton skeleton-small-text"></div>
                </div>
              </div>
            }
          }
        </div>
  
        @if (!isMobile) {
          <div class="pill-content-side" (click)="onMoveToNext()">
            <svg
              xmlns="http://www.w3.org/2000/svg" 
              width="22"
              height="34"
              viewBox="0 0 22 34"
              fill="none"
              [class.arrow-left]="direction === directions.RightLeft"
              [class.arrow-right]="direction === directions.LeftRight"
              [class.hidden]="menuOptionsSignal().length < 2"
              class="arrow-icon"
            >
              <path d="M14.9528 16.9977L0.987301 5.00645C0.429876 4.52398 0.0807056 3.83356 0.0162563 3.08638C-0.048193 2.3392 0.17733 1.59614 0.643438 1.01994C1.10955 0.443733 1.77826 0.0813368 2.50312 0.0121084C3.22799 -0.0571199 3.94995 0.172462 4.51089 0.650579L21.0116 14.8197C21.321 15.0861 21.5699 15.4192 21.7407 15.7955C21.9115 16.1719 22 16.5823 22 16.9977C22 17.4131 21.9115 17.8235 21.7407 18.1999C21.5699 18.5762 21.321 18.9093 21.0116 19.1757L4.51089 33.3448C3.9502 33.8252 3.22737 34.0566 2.50119 33.9882C1.77502 33.9198 1.10488 33.5572 0.637987 32.98C0.171095 32.4029 -0.0543671 31.6583 0.0111294 30.91C0.0766258 30.1616 0.427729 29.4706 0.987301 28.9889L14.9528 16.9977Z" fill="#2DADC8"/>
            </svg>
          </div>
        }
      </div>
    } @else {
      <div class="pill-mini" (click)="onPillToggle(true)">
        <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="26" height="4" rx="2" fill="#2DADC8" stroke="#2DADC8"/>
          <rect x="0.5" y="12.5" width="26" height="4" rx="2" fill="#2DADC8" stroke="#2DADC8"/>
        </svg>
      </div>
    }
  } @else {
    <div class="pill-expanded-content">
      <div class="pill-expanded-content-header">
        <div class="pill-expanded-content-header-side left" (click)="onPillToggle(false)">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="3.51953" y="0.691331" width="26" height="4" rx="2" transform="rotate(45 3.51953 0.691331)" fill="#2DADC8" stroke="#2DADC8"/>
            <rect x="0.292893" y="18.6875" width="26" height="4" rx="2" transform="rotate(-45 0.292893 18.6875)" fill="#2DADC8" stroke="#2DADC8"/>
          </svg>
        </div>
  
        <div class="pill-expanded-content-header-section">
          <h2 class="pill-expanded-content-header-section-title">{{ 'WebApp.v1.Shared.Pill.Title' | translate }}</h2>
          <p class="pill-expanded-content-header-section-subtitle">{{ 'WebApp.v1.Shared.Pill.Subtitle' | translate: { companyName } }}</p>
        </div>

        <div class="pill-expanded-content-header-side right" (click)="onGoToHome()">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M13.002 1.40039C13.1849 1.40039 13.3663 1.43649 13.5352 1.50684C13.7031 1.57683 13.856 1.6787 13.9844 1.80762L21.8398 9.66406L24.1943 12.0186L24.2871 12.1191C24.3743 12.2245 24.4453 12.343 24.498 12.4697C24.5683 12.6384 24.6044 12.8193 24.6045 13.002C24.6045 13.1849 24.5684 13.3663 24.498 13.5352C24.4283 13.7024 24.3254 13.8534 24.1973 13.9814L24.1982 13.9824C24.0694 14.1123 23.9159 14.2158 23.7471 14.2861C23.5784 14.3563 23.3975 14.3925 23.2148 14.3926C23.032 14.3926 22.8504 14.3564 22.6816 14.2861C22.5178 14.2179 22.3695 14.1176 22.2432 13.9932V23.2148C22.2431 23.5821 22.0976 23.9346 21.8379 24.1943C21.5781 24.4542 21.2249 24.5996 20.8574 24.5996H5.14648C4.77914 24.5995 4.42676 24.4541 4.16699 24.1943C3.90724 23.9346 3.76085 23.5822 3.76074 23.2148V13.9932C3.63448 14.1174 3.48687 14.2179 3.32324 14.2861C3.1544 14.3565 2.97295 14.3926 2.79004 14.3926C2.60715 14.3926 2.42566 14.3565 2.25684 14.2861C2.08961 14.2164 1.93856 14.1135 1.81055 13.9854C1.68072 13.8566 1.57718 13.704 1.50684 13.5352C1.43649 13.3663 1.40039 13.1849 1.40039 13.002C1.40043 12.8192 1.43658 12.6384 1.50684 12.4697C1.57715 12.3009 1.67978 12.1473 1.80957 12.0186L4.16504 9.66406L12.0205 1.80762C12.1489 1.67874 12.3018 1.5768 12.4697 1.50684C12.6384 1.43658 12.8192 1.40043 13.002 1.40039ZM6.53223 11.2158V21.8291H19.4727V11.2158L13.002 4.74609L6.53223 11.2158Z" fill="#2DADC8" stroke="#2DADC8" stroke-width="1.2"/>
          </svg>
        </div>
      </div>
  
      <div class="pill-expanded-content-body">
        @for (section of sections; track section) {
          <div class="pill-expanded-content-body-section">
            <div class="pill-expanded-content-body-section-title">
              <div class="resource-icon title">
                <i class="title-icon fa-solid" [ngClass]="section.icon"></i>
              </div>
              <h3 class="title">{{ section.title | translate }}</h3>
            </div>

            <div class="resource-items" [class.why]="section.title === 'Why'">
              @for (resource of section.resources; track resource) {
                <div class="resource-item" (click)="onResourceItemClick(resource)">
                  <div class="resource-icon">
                    <i class="pill-content-menu-icon" [ngClass]="resource.icon"></i>
                  </div>
                  <div class="resource-content">
                    <h4>{{ resource.title | translate }}</h4>
                    <p>{{ resource.description | translate }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="pill-expanded-content-footer">
        <div class="footer-button">
          <a class="resource-content" routerLink="/account">
            <i class="fa-solid fa-user footer-icon"></i>
            {{ 'WebApp.v1.Shared.Pill.Account' | translate }}
          </a>
        </div>
        <div class="footer-button">
          <a class="resource-content" routerLink="/settings">
            <i class="fa-solid fa-gear footer-icon"></i>
            {{ 'WebApp.v1.Shared.Pill.Settings' | translate }}
          </a>
        </div>
      </div>
    </div>
  }
</div>
